import { useCallback, useContext } from 'react';
import { CopilotChannelContext } from '../channel/CopilotChannelContext';
// WARNING: this is a hook to enable free context in the copilot app, this free context can be used to pass additional context to a custom AI Tool.
// If your use-case is to pass structured context like CRM objects, App ids, etc. use useSetCopilotAppContext instead.
export const useSetCopilotFreeContext = () => {
  const {
    channel
  } = useContext(CopilotChannelContext);
  return useCallback((freeContext, clearContext = false) => {
    if (channel && typeof channel.getVersion === 'function' && channel.getVersion() >= 1) {
      channel.setState(({
        freeContext: prevFreeContext
      }) => {
        return {
          freeContext: Object.assign({}, clearContext ? {} : prevFreeContext, freeContext || {})
        };
      });
    }
  }, [channel]);
};